import React from 'react';
import Card from '../components/Card';
import Button from '../components/Button';

const About = () => {
    return (
        <>
            {/* Hero Section */}
            {/* Hero Section */}
            <section className="hero hero-right about-hero">
                <div style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundColor: 'rgba(0, 0, 0, 0.6)'
                }}></div>
                <div className="hero-content" style={{ position: 'relative', zIndex: 1 }}>
                    <h1 className="hero-title">About Deccan Arts</h1>
                    <p className="hero-subtitle">Preserving Tamil Martial Heritage</p>
                </div>
            </section>

            {/* History of Silambam Section */}
            <section className="section section-dark">
                <div className="section-header">
                    <h2 className="section-title">History of Silambam</h2>
                </div>
                <div style={{ maxWidth: '1000px', margin: '0 auto' }}>
                    <p style={{ fontSize: '1.2rem', lineHeight: '1.9', marginBottom: '1.5rem' }}>
                        Silambam is one of the oldest martial arts in the world, with roots tracing back over 5,000 years to ancient Tamil Nadu.
                        The art was traditionally practiced by Tamil warriors and kings, and was an essential part of military training in the
                        Chola, Chera, and Pandya dynasties.
                    </p>
                    <p style={{ fontSize: '1.2rem', lineHeight: '1.9', marginBottom: '1.5rem' }}>
                        The name "Silambam" comes from the Tamil words "silam" (hill) and "bambu" (staff), referring to the bamboo sticks that
                        grew in the Kurinji hills of Tamil Nadu. These sticks became the primary weapon of this martial art, known for their
                        flexibility, durability, and effectiveness in combat.
                    </p>
                    <p style={{ fontSize: '1.2rem', lineHeight: '1.9', marginBottom: '1.5rem' }}>
                        Throughout history, Silambam masters traveled across Southeast Asia, spreading the art to countries like Malaysia,
                        Singapore, and Indonesia. Today, Silambam is recognized as a national martial art of India and is practiced by enthusiasts
                        worldwide who seek to preserve this ancient tradition.
                    </p>
                </div>
            </section>

            {/* My Journey Section */}
            <section className="section section-gradient">
                <div className="section-header">
                    <h2 className="section-title">Our Journey as a Silambam Practitioner</h2>
                </div>
                <div style={{ maxWidth: '1000px', margin: '0 auto' }}>
                    <p style={{ fontSize: '1.2rem', lineHeight: '1.9', marginBottom: '1.5rem' }}>
                        Our journey with Silambam began over 8 years ago when I first witnessed a master demonstration at a traditional Tamil
                        festival. The speed, grace, and power of the movements immediately captivated me, and I knew I had found my calling.
                    </p>
                    {/* <p style={{ fontSize: '1.2rem', lineHeight: '1.9', marginBottom: '1.5rem' }}>
                        I trained intensively under renowned Silambam masters in Tamil Nadu, learning not just the physical techniques, but also
                        the philosophy, history, and cultural significance of this ancient art. I earned my black belt certification and went on
                        to compete in national and international championships, winning multiple gold medals.
                    </p> */}
                    <p style={{ fontSize: '1.2rem', lineHeight: '1.9', marginBottom: '1.5rem' }}>
                        Over the years, I've had the privilege of training thousands of students, from complete beginners to advanced practitioners.
                        I've witnessed firsthand how Silambam transforms lives—building confidence, discipline, fitness, and a deep connection to
                        Tamil heritage.
                    </p>
                    <p style={{ fontSize: '1.2rem', lineHeight: '1.9', marginBottom: '1.5rem' }}>
                        When the pandemic made in-person training difficult, I adapted by creating comprehensive online training programs. Now,
                        students from around the world can learn authentic Silambam from the comfort of their homes, with live instruction,
                        personalized feedback, and a supportive global community.
                    </p>
                </div>
            </section>

            {/* Mission Section */}
            <section className="section section-dark">
                <div className="section-header">
                    <h2 className="section-title">Our Mission</h2>
                </div>
                <div className="cards-grid">
                    <Card icon="🏛️" title="Preserve Tradition" text="Keep the ancient Tamil martial art of Silambam alive by teaching authentic techniques passed down through generations of masters." />
                    <Card icon="🌍" title="Global Accessibility" text="Make Silambam training accessible to people worldwide through high-quality online classes and comprehensive curriculum." />
                    <Card icon="👥" title="Empower Students" text="Transform lives through martial arts training, building physical fitness, mental discipline, and cultural pride." />
                    <Card icon="📚" title="Education & Awareness" text="Educate the world about Tamil martial heritage and its importance in Indian cultural history." />
                    <Card icon="🏆" title="Excellence in Training" text="Provide world-class instruction with structured curriculum, personalized feedback, and professional certification." />
                    <Card icon="🤝" title="Build Community" text="Create a global community of Silambam practitioners who support, inspire, and learn from each other." />
                </div>
            </section>

            {/* Training Methods Section */}
            <section className="section section-gradient">
                <div className="section-header">
                    <h2 className="section-title">Training Methods</h2>
                </div>
                <div style={{ maxWidth: '1000px', margin: '0 auto' }}>
                    <div className="course-card" style={{ marginBottom: '2rem' }}>
                        <h3 className="course-title">Live Online Classes</h3>
                        <p style={{ fontSize: '1.1rem', lineHeight: '1.8', color: 'var(--color-gray-light)' }}>
                            Our primary training method is live, interactive classes conducted via Zoom. These sessions allow for real-time
                            instruction, correction, and personalized feedback. You'll train alongside students from around the world, creating
                            a motivating and supportive learning environment.
                        </p>
                    </div>
                    <div className="course-card" style={{ marginBottom: '2rem' }}>
                        <h3 className="course-title">Recorded Sessions</h3>
                        <p style={{ fontSize: '1.1rem', lineHeight: '1.8', color: 'var(--color-gray-light)' }}>
                            Every class is recorded and made available to students for review. This allows you to practice at your own pace,
                            revisit techniques, and ensure you never miss a lesson even if you can't attend live.
                        </p>
                    </div>
                    <div className="course-card" style={{ marginBottom: '2rem' }}>
                        <h3 className="course-title">Structured Curriculum</h3>
                        <p style={{ fontSize: '1.1rem', lineHeight: '1.8', color: 'var(--color-gray-light)' }}>
                            Our courses follow a carefully designed progression from beginner to professional level. Each level builds on the
                            previous one, ensuring a solid foundation and steady advancement in skills.
                        </p>
                    </div>
                    <div className="course-card" style={{ marginBottom: '2rem' }}>
                        <h3 className="course-title">Personalized Attention</h3>
                        <p style={{ fontSize: '1.1rem', lineHeight: '1.8', color: 'var(--color-gray-light)' }}>
                            Small class sizes ensure that every student receives individual attention and feedback. You can ask questions,
                            submit videos for review, and get customized guidance to improve your technique.
                        </p>
                    </div>
                </div>
            </section>

            {/* Certification Section */}
            <section className="section section-dark">
                <div className="section-header">
                    <h2 className="section-title">Certification Details</h2>
                </div>
                <div style={{ maxWidth: '1000px', margin: '0 auto' }}>
                    <p style={{ fontSize: '1.2rem', lineHeight: '1.9', marginBottom: '2rem', textAlign: 'center' }}>
                        Upon successful completion of each level, students receive official certification recognizing their achievement and skill level.
                    </p>
                    <div className="cards-grid">
                        <Card title="Beginner Certification" text="Awarded after mastering fundamental techniques, grips, footwork, and basic strikes. Qualifies you to advance to intermediate training." />
                        <Card title="Intermediate Certification" text="Recognizes proficiency in advanced spins, combinations, and coordination drills. Prepares you for professional-level training." />
                        <Card title="Advanced/Professional Certification" text="The highest level of certification, demonstrating mastery of combat techniques, choreography, and sparring. Qualifies you to teach others." />
                        {/* <Card title="Weapon Specialization" text="Additional certifications available for mastery of specific weapons like Surul Vaal, Maan Kombu, and Double Stick." /> */}
                    </div>
                    <div style={{ textAlign: 'center', marginTop: '3rem' }}>
                        {/* <p style={{ fontSize: '1.1rem', color: 'var(--color-gold-light)', marginBottom: '1.5rem' }}>
                            All certifications are officially recognized and can be used for teaching credentials, competition entries, and professional development.
                        </p> */}
                        <Button to="/registration">Start Your Certification Journey</Button>
                    </div>
                </div>
            </section>
        </>
    );
};

export default About;
